module.exports = __webpack_public_path__ + "static/img/code.153ac1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live/code.png
// module id = TKhT
// module chunks = 1